import { render } from "./FooterCell.vue?vue&type=template&id=4224bf80"
import script from "./FooterCell.vue?vue&type=script&lang=js"
export * from "./FooterCell.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\60\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__